export default __webpack_public_path__ + "static/OperatorMono-BoldItalic_Web-03ef637890714a054d22afc8ea16738b.woff2";